import React from "react";
import { RightPanel } from "../../../../../../components/RightPanel";
import { HabitationalCoverages } from "./HabitationalCoverages";
import { IHabitationalCoverages } from "../../../../../../redux/habitationalPolicy/habitationalCoverages/habitationalCoverages.types";

interface IHabitationalCoverageRightPanelProps {
  open: boolean;
  customerId?: number;
  customerPolicyId?: number;
  interestedNumber?: number;
  onSaveSuccess: (data: IHabitationalCoverages) => void;
  readonly?: boolean;
  onClose: () => void;
  staticStatusValue?: string;
  createdFrom?: string;
  initialData?: IHabitationalCoverages;
  disableApiCalls?: boolean;
}

export const HabitationalCoverageRightPanel: React.FC<
IHabitationalCoverageRightPanelProps
> = (props) => {
  const {
    customerId,
    customerPolicyId,
    interestedNumber,
    onClose,
    onSaveSuccess,
    readonly,
    staticStatusValue,
    createdFrom,
    initialData,
    disableApiCalls
  } = props;

  return (
    <>
      <RightPanel
        heading="Coverage"
        //subHeading="Add notes or comments"
        open={true}
        onClose={onClose}
        width="80%"
      >
        <HabitationalCoverages
          customerId={customerId}
          customerPolicyId={customerPolicyId}
          interestedNumber={interestedNumber}
          onSaveSuccess={onSaveSuccess}
          readOnly={readonly}
          fromRightPanel
          staticStatusValue={staticStatusValue}
          createdFrom={createdFrom}
          disableApiCalls={disableApiCalls}
          initialData={initialData}
        />
      </RightPanel>
    </>
  );
};
